'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _naturalSort = require('natural-sort');

var _naturalSort2 = _interopRequireDefault(_naturalSort);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactRedux = require('react-redux');

var _ramda = require('ramda');

var _helpers = require('./../../helpers');

var _app = require('redux/modules/app');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PageHome.scss');
var ketakaLogo = require('./ketaka-logo.png');

var PageHome = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _app.listApps)());
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return (0, _helpers.mapConnect)(state, {
    apps: 'app.apps',
    displayMethod: 'app.displayMethod',
    searchKeyword: 'app.searchKeyword',
    sortDirection: 'app.sortDirection'
  });
}, { setSearchKeyword: _app.setSearchKeyword, setDisplayMethod: _app.setDisplayMethod, toggleSortDirection: _app.toggleSortDirection }), _dec(_class = _dec2(_class = (0, _reactIntl.injectIntl)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PageHome, _Component);

  function PageHome() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PageHome);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = PageHome.__proto__ || (0, _getPrototypeOf2.default)(PageHome)).call.apply(_ref2, [this].concat(args))), _this), _this.limitText = function (id) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 46;

      var text = _this.props.intl.formatMessage({ id: id });
      if (text.length > length) {
        text = text.substring(0, length) + '\u2026';
      }
      return text;
    }, _this.stripHtml = function (html) {
      return html.replace(/<[^>]*>/g, '');
    }, _this.handleSearchInputChange = function (event) {
      _this.props.setSearchKeyword(event.target.value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PageHome, [{
    key: 'renderRow',
    value: function renderRow(arr) {
      var _this2 = this;

      var displayMethod = this.props.displayMethod;

      return arr.map(function (app) {
        return _react2.default.createElement(
          _reactRouterBootstrap.LinkContainer,
          { key: 'app-' + app.id, to: '/apps/' + app.id },
          _react2.default.createElement(
            'a',
            { href: '' },
            _react2.default.createElement(
              'figure',
              null,
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                _react2.default.createElement(
                  'div',
                  { className: styles.app },
                  _react2.default.createElement(
                    'div',
                    { className: styles.titleBlock },
                    _react2.default.createElement(
                      'h3',
                      { className: styles.appTitle },
                      _react2.default.createElement('img', { src: '/list/' + app.imageListPage, alt: app.imageListAlt }),
                      _react2.default.createElement(_reactIntl.FormattedMessage, { id: app.titleId })
                    )
                  ),
                  _react2.default.createElement(
                    'figcaption',
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: styles.descBlock },
                      'grid' === displayMethod && _react2.default.createElement(
                        'div',
                        { className: styles.desc },
                        _this2.stripHtml(_this2.limitText(app.introContentId))
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.detail },
                        _react2.default.createElement(
                          'div',
                          { className: styles.platform },
                          app.platforms.join(' / ')
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        );
      });
    }
  }, {
    key: 'filterKeyword',
    value: function filterKeyword(apps) {
      var _props = this.props,
          searchKeyword = _props.searchKeyword,
          intl = _props.intl;
      var formatMessage = intl.formatMessage;

      var keyword = searchKeyword.toLowerCase();

      if (!keyword) {
        return apps;
      }
      return apps.filter(function (app) {
        var title = formatMessage({ id: app.titleId }).toLowerCase();
        if (-1 !== title.indexOf(keyword)) {
          return true;
        }
        var text = formatMessage({ id: app.introContentId }).toLowerCase();
        if (-1 !== (text || '').indexOf(keyword)) {
          return true;
        }
        return false;
      });
    }
  }, {
    key: 'sort',
    value: function sort(apps) {
      var _props2 = this.props,
          intl = _props2.intl,
          sortDirection = _props2.sortDirection;
      var formatMessage = intl.formatMessage;

      return apps.sort(function (app1, app2) {
        var title1 = formatMessage({ id: app1.titleId });
        var title2 = formatMessage({ id: app2.titleId });
        return (0, _naturalSort2.default)({ direction: sortDirection })(title1, title2);
      });
    }
  }, {
    key: 'split',
    value: function split(apps) {
      if ('grid' === this.props.displayMethod) {
        return (0, _ramda.splitEvery)(3, apps);
      }
      return [apps];
    }
  }, {
    key: 'renderApps',
    value: function renderApps() {
      var _this3 = this;

      var apps = this.props.apps;

      return this.split(this.sort(this.filterKeyword(apps))).map(function (arr, index) {
        return _react2.default.createElement(
          'div',
          { key: 'row-' + index, className: 'row' },
          _this3.renderRow(arr)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          searchKeyword = _props3.searchKeyword,
          displayMethod = _props3.displayMethod,
          setDisplayMethod = _props3.setDisplayMethod,
          toggleSortDirection = _props3.toggleSortDirection,
          sortDirection = _props3.sortDirection;


      return _react2.default.createElement(
        'div',
        { className: styles.pageHome },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: styles.hero },
          _react2.default.createElement('img', { className: styles.ketakaLogo, src: ketakaLogo, alt: 'ketaka logo' }),
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'home-heading' })
          ),
          _react2.default.createElement(
            'h2',
            { className: styles.intro },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'home-intro' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appListContainer },
          _react2.default.createElement(
            'div',
            { className: styles.appToolbar + ' clearfix' },
            _react2.default.createElement(
              'div',
              { className: styles.formSearch },
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  _reactBootstrap.InputGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup.Addon,
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-fw fa-search' })
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', onChange: this.handleSearchInputChange, value: searchKeyword })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.toolbar },
              _react2.default.createElement(
                'span',
                null,
                '\u6392\u5217\u65B9\u5F0F'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  { className: styles.pipe },
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { onClick: toggleSortDirection },
                    _react2.default.createElement('i', { className: 'fa fa-fw fa-sort-alpha-' + sortDirection })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.pipe },
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { onClick: setDisplayMethod.bind(this, 'grid') },
                    _react2.default.createElement('i', { className: 'fa fa-fw fa-th-large' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { onClick: setDisplayMethod.bind(this, 'list') },
                    _react2.default.createElement('i', { className: 'fa fa-fw fa-list-ul' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.appList + ' ' + styles[displayMethod] + ' container' },
            this.renderApps()
          )
        )
      );
    }
  }]);
  return PageHome;
}(_react.Component), _class2.propTypes = {
  apps: _react.PropTypes.array.isRequired,
  intl: _react.PropTypes.object.isRequired,
  searchKeyword: _react.PropTypes.string.isRequired,
  sortDirection: _react.PropTypes.string.isRequired,
  setSearchKeyword: _react.PropTypes.func.isRequired,
  setDisplayMethod: _react.PropTypes.func.isRequired,
  toggleSortDirection: _react.PropTypes.func.isRequired,
  displayMethod: _react.PropTypes.string.isRequired
}, _temp2)) || _class) || _class) || _class);
exports.default = PageHome;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PageHome/PageHome.js
 ** module id = 1238
 ** module chunks = 0
 **/